export const obtenerPorcentaje = ({valor, rebajado}) => {

   // console.log('valor', valor)
   // console.log(rebajado)

    if (!valor || valor <= 0) return 0;

    let valorDes = rebajado - valor

    return (valorDes / rebajado * 100).toFixed(0)


}